var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleLightTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6875 7.216C3.6875 5.44 5.12677 4 6.9026 4C8.67851 4 10.1186 5.44009 10.1186 7.216C10.1186 8.99183 8.6786 10.4311 6.9026 10.4311C5.12669 10.4311 3.6875 8.99191 3.6875 7.216ZM8.6186 7.216C8.6186 6.26851 7.85009 5.5 6.9026 5.5C5.95537 5.5 5.1875 6.26826 5.1875 7.216C5.1875 8.16349 5.95511 8.9311 6.9026 8.9311C7.85034 8.9311 8.6186 8.16323 8.6186 7.216Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90258 9.21875C9.85375 9.21875 12.2603 11.553 12.3759 14.4753L12.3803 14.6955V15.6189L10.8803 15.6189V14.6955C10.8803 12.4996 9.09915 10.7188 6.90258 10.7188C4.77333 10.7188 3.0341 12.3935 2.93065 14.4971L2.92578 14.6955V15.6189H1.42578L1.42578 14.6955C1.42578 11.6713 3.87837 9.21875 6.90258 9.21875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.082 7.216C11.082 5.43982 12.5215 4 14.298 4C16.0732 4 17.5131 5.44027 17.5131 7.216C17.5131 8.99165 16.0733 10.4311 14.298 10.4311C12.5214 10.4311 11.082 8.99209 11.082 7.216ZM16.0131 7.216C16.0131 6.26861 15.2447 5.5 14.298 5.5C13.35 5.5 12.582 6.26816 12.582 7.216C12.582 8.16358 13.3497 8.9311 14.298 8.9311C15.245 8.9311 16.0131 8.16313 16.0131 7.216Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2974 9.21875C17.2486 9.21875 19.6543 11.553 19.7699 14.4761L19.7742 14.6965V15.6189H18.2742V14.6965C18.2742 12.4995 16.4939 10.7188 14.2974 10.7188C13.146 10.7188 12.0777 11.2097 11.3302 12.0476L11.1851 12.2198L10.0117 11.2853C11.0439 9.98927 12.6075 9.21875 14.2974 9.21875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleLightTheme);
export default __webpack_public_path__ + "static/media/people_light_theme.3434e5026ad33f84056ecf988f9487fe.svg";
export { ForwardRef as ReactComponent };